module.exports = __webpack_public_path__ + "static/img/logo-assurance-maladie.7d081ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-assurance-maladie.jpg
// module id = YlzK
// module chunks = 1